import './rowList.css'
import React, { useState, useEffect} from "react";
import {
  Button,
  Card,
  Container,
  Modal,
} from "react-bootstrap";
import { Link, useNavigate  } from "react-router-dom";
import "../../Style.css";
import { useSelector } from "react-redux";
import TimeAgo from "../../components/timeAgo/TimeAgo";
import { FaEdit, FaTrash, FaUserCheck, FaUserPlus, FaShareAlt } from 'react-icons/fa';
import { SlOptionsVertical } from "react-icons/sl";
import DefaultImage from "../../../assets/images/DefaultImage.jpeg";
import ShareButtons from './ShareButtons';


const RowList = ({
  title,
  data,
  route,
  handleDelete,
  handleToggleEnable,
  CardImg,
  creator,
  createOn, 
  item,
  checkBox,
  isFollowing,
  onToggleFollow,
  isShared, 
  onToggleShare,
}) => {
  const loggedInUser = useSelector((state) => state.auth.user);
  const userType = loggedInUser?.userDetails?.userType;
  const roles = loggedInUser?.userDetails?.roles;
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const shareUrl = `${window.location.origin}/dashboard/propertyDashboard/${item.id}`;

  const userId = loggedInUser?.userDetails?.id;
  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const [itemIdToDelete, setItemIdToDelete] = useState(null);
  const [localData, setLocalData] = useState(data);
  const [menuVisible, setMenuVisible] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    setLocalData(data);
  }, [data]);

  const handleDeleteAlertClose = () => {
    setShowDeleteAlert(false);
    setItemIdToDelete(null);
  };

  const handleDeleteAlertShow = (itemId) => {

    setShowDeleteAlert(true);
    setItemIdToDelete(itemId);
  };

  const handleDeleteConfirmed = () => {
    handleDelete(itemIdToDelete);
    handleDeleteAlertClose();
  };

  const accessControlAxis = [
    {
      page: "promotion-list",
      allowedUserTypes: ["SUPER_ADMIN", "ALL_HOME_DESIRE"],
      role: [],
      canEditDelete: true,
    },
    {
      page: "property",
      allowedUserTypes: ["SUPER_ADMIN", "ALL_HOME_DESIRE"],
      role: [],
      canEditDelete: true,
      canFollow: true,
    },
    {
      page: "post",
      allowedUserTypes: ["SUPER_ADMIN", "ALL_HOME_DESIRE"],
      role: [],
      canEditDelete: true,
    },
    {
      page: "/admin/posts",
      allowedUserTypes: ["SUPER_ADMIN", "ALL_HOME_DESIRE"],
      role: [],
      canEditDelete: true,
    },
    {
      page: "/admin/properties",
      allowedUserTypes: ["SUPER_ADMIN", "ALL_HOME_DESIRE"],
      role: [],
      canEditDelete: true,
      canFollow: true,
    },
    {
      page: "/admin/promotions",
      allowedUserTypes: ["SUPER_ADMIN", "ALL_HOME_DESIRE"],
      role: [],
      canEditDelete: true,
    },
    {
      page: "/dashboard/postDashboard",
    }, 
    {
      page: "/dashboard/propertyDashboard",
      canFollow: true,
    },
    {
      page: "/dashboard/myspace",
      canFollow: true,
    },
    {
      page: "/dashboard/promotionDashboard",
    },
  ];

  // accessControlAxis se current page ke access permissions nikalna
  const currentPageAccess = accessControlAxis.find(
    (entry) => entry.page === route
  );

  // agar currentPageAccess nahi milta hai ya Edit/Delete ka axis nahi hai, toh default false set kardo
  const isEditDeleteAllowed = currentPageAccess
    ? currentPageAccess.canEditDelete
    : false;

  // agar Edit/Delete allowed hai aur user type allowed list mein hai, toh buttons dikhao
  const isUserAuthorized =
    isEditDeleteAllowed &&
    (currentPageAccess.allowedUserTypes.includes(userType) ||
      (userType === "PARTNER" &&
        roles.includes("ROLE_ADMIN") &&
        currentPageAccess.role.includes("ROLE_ADMIN")));

  const toggleMenu = (e) => {
    e.preventDefault();
    setMenuVisible((prev) => !prev);
  };

  return (
      <Container> 
      <Modal
          show={showDeleteAlert}
          onHide={handleDeleteAlertClose}
          centered
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Are you sure you want to Delete ?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={handleDeleteAlertClose}
              variant="outline-secondary"
              className="me-3"
            >
              Cancel
            </Button>
            <Button onClick={handleDeleteConfirmed} variant="danger">
              
            Delete
            </Button>
          </Modal.Footer>
      </Modal>
   
      <section
        className="saas-row-item"
        onClick={(e) => {
          e.preventDefault();
          if (e.target.closest('.no-nav')) return;
          navigate(`${route}/${item?.id}`);
        }}
      >
        <div className="d-flex flex-column flex-md-row align-items-center justify-content-between gap-3">
          {/* Image */}
          <div className="saas-row-item__image">
            <img 
              src={CardImg || DefaultImage}
              alt={title}
              loading="lazy"
            />
          </div>

          {/* Text Content */}
          <div className="flex-grow-1 text-center text-md-start">
            <h5 className="saas-row-item__title text-truncate" title={title}>{title}</h5>
            <div className="saas-row-item__meta">
              <span>By <strong className="text-dark">{creator || "Community Member"}</strong></span>
              <span>•</span>
              <span className="text-muted"><TimeAgo timestamp={createOn} /></span>
              {item?.city_name && (
                <>
                  <span>•</span>
                  <span>{item.city_name}</span>
                </>
              )}
            </div>
          </div>

          {/* Toggle */}
          {handleToggleEnable &&
            (route === "/property" || route === "/promotion-list" || route === "/post" || 
             route === "/admin/properties" || route === "/admin/promotions" || route === "/admin/posts") && (
              <div className="form-check form-switch toggle-area">
                <input
                  className="form-check-input no-nav"
                  type="checkbox"
                  id={`toggleSwitch${item.id}`}
                  checked={checkBox}
                  onChange={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleToggleEnable(item.id, e);
                  }}
                />
                <label
                  className={`form-check-label ms-2 fw-semibold ${
                    checkBox ? "text-success" : "text-danger"
                  }`}
                  htmlFor={`toggleSwitch${item.id}`}
                >
                  {checkBox ? "Published" : "Unpublished"}
                </label>
              </div>
            )}


          {/* 3-dot menu */}
          <div className="card-menu-wrapper position-relative">
            <Button 
              variant="light"
              className="border-0 bg-transparent shadow-none no-nav card-menu-trigger"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                toggleMenu(e);
              }}
            >
              <SlOptionsVertical className="menu"/>
            </Button>

            {menuVisible && (
              <div className="card-menu-dropdown">
                {(route === "/property" || route === "/post" || route === "/admin/properties" || route === "/admin/posts" || route?.startsWith("/customer/myspace")) && (
                  <Link
                    to={item?.service ? `/post/${item?.id}/edit` : `/property/${item?.id}/edit`}
                    className="dropdown-item-custom text-success no-nav"
                  >
                    <FaEdit className="me-2" /> Edit
                  </Link>
                )}

                {(route === "/property" || route === "/post" || route === "/promotion-list" ||
                  route === "/admin/properties" || route === "/admin/posts" || route === "/admin/promotions" || route?.startsWith("/customer/myspace")) && (
                  <button
                    className="dropdown-item-custom text-danger no-nav"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleDeleteAlertShow(item.id);
                    }}
                  >
                    <FaTrash className="me-2" /> Delete
                  </button>
                )}

                {/* { accessControlAxis.canFollow && */}
                {/* { accessControlAxis.canFollow && how to make this happen */}
                {currentPageAccess?.canFollow && 
                  <>
                    <button
                      className={`dropdown-item-custom no-nav ${
                        isFollowing ? "text-primary" : "text-secondary"
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onToggleFollow(item.id);
                      }}
                    >
                      {isFollowing ? (
                        <>
                          <FaUserCheck className="me-2" /> Following
                        </>
                      ) : (
                        <>
                          <FaUserPlus className="me-2" /> Follow
                        </>
                      )}
                    </button>
                    {/* Share Button */}
                    <button
                      className={`dropdown-item-custom no-nav ${
                        isShared ? "text-success" : "text-secondary"
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onToggleShare(item.id, isShared);
                      }}
                    >
                      <FaShareAlt className="me-2" />
                      {isShared ? "Shared" : "Share"}
                    </button>
                    {/* Share Buttons */}
                    <ShareButtons
                      item={item}
                      shareUrl={shareUrl}
                      cardImg={CardImg}
                      defaultImage={DefaultImage}
                    />
                  </>
                }  
                  
                  
              </div>
            )}
          </div>
        </div>
      </section>





      </Container>
  );
};

export default RowList;

